var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgViewSide(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 223.45 517.52",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.84,48.44C171.38,35.22,168.25,19.89,167.63,3,142.44-4.1,118.3,2.59,98,23,85.51,35.56,63.6,59.15,65.52,76.17c38.07-9.9,67.79-39.06,112.32-27.73Z",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.32,429.48l7.73,6.3c42,22.41,142.78,20.66,186.91-4.72,13.67-6.2,18.75-17.93,12.75-36.82-9.46-24.27-2.32-19.92-3.5-34.74-.37-4.63-4.84-9.28-5.21-13.92l0-15.06-11.54-20.35L214.37,207.8c6.84-13.62,7-31.24,3-51.35-1.83-9.28-5.07-17.44-6.94-26.35-2.56-12.16-3.13-25.18-7.3-36.63a155,155,0,0,0-25.33-45C133.31,37.11,103.59,66.27,65.52,76.17L28.13,148.39C14,177.44,10.21,201.45,11.23,223.17c1.48,31.56-2.53,63.13-6.07,100.48C3.42,342,1.49,361.35.5,379.78-.66,401.41,2,419.52,13.32,429.48Z",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110.77,503c49.34-2.72,89.36-8.74,97.45-26-.09-15.65-.18-30.23-.26-45.88-47,27-158.43,27.25-194.37,0-.09,15.65-.17,30.23-.26,45.88,8.09,17.3,48.11,23.32,97.44,26Z",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M72,453c23.49,5.85,41,16.13,53.66,29.92L100,517.23c-22.13-6.67-38.1-16.29-48.62-28.52L72,453Z",
    style: {
      fill: "none",
      clipRule: "evenodd"
    }
  }))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "view-side") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M177.84,48.44C171.38,35.22,168.25,19.89,167.63,3,142.44-4.1,118.3,2.59,98,23,85.51,35.56,63.6,59.15,65.52,76.17c38.07-9.9,67.79-39.06,112.32-27.73Z",
    style: {
      fill: "#404041",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M77.87,75.27A185.28,185.28,0,0,1,90.08,59.36,125.41,125.41,0,0,1,104,45.51c9-7.61,18-14.13,29.78-18.11s26-5.35,45.43-2.66l-1,7C160,29.2,146.76,30.44,136,34.08s-19.06,9.7-27.5,16.81A118.43,118.43,0,0,0,95.41,64a174.57,174.57,0,0,0-11.74,15.3l-5.8-4Zm-12.64,2.1A252.23,252.23,0,0,1,81.69,53a134.68,134.68,0,0,1,19.52-20.73c9-7.61,18-14.13,29.78-18.11s26-5.35,45.43-2.66l-1,7C157.22,16,144,17.19,133.26,20.83s-19.06,9.69-27.49,16.81A128.26,128.26,0,0,0,87.26,57.29,248,248,0,0,0,71.28,81l-6-3.65Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M177.84,48.44C171.38,35.22,168.25,19.89,167.63,3,142.44-4.1,118.3,2.59,98,23,85.51,35.56,63.6,59.15,65.52,76.17c38.07-9.9,67.79-39.06,112.32-27.73Z",
    style: {
      fill: "none",
      stroke: "#231f20",
      strokeMiterlimit: 2.613126039505005,
      strokeWidth: "0.500029981136322px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.32,429.48l7.73,6.3c42,22.41,142.78,20.66,186.91-4.72,13.67-6.2,18.75-17.93,12.75-36.82-9.46-24.27-2.32-19.92-3.5-34.74-.37-4.63-4.84-9.28-5.21-13.92l0-15.06-11.54-20.35L214.37,207.8c6.84-13.62,7-31.24,3-51.35-1.83-9.28-5.07-17.44-6.94-26.35-2.56-12.16-3.13-25.18-7.3-36.63a155,155,0,0,0-25.33-45C133.31,37.11,103.59,66.27,65.52,76.17L28.13,148.39C14,177.44,10.21,201.45,11.23,223.17c1.48,31.56-2.53,63.13-6.07,100.48C3.42,342,1.49,361.35.5,379.78-.66,401.41,2,419.52,13.32,429.48Z",
    style: {
      fill: "#404041",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-2)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.91,318.45c10.33,28.9,21.42,55.4,34.17,76.57l6.48-8.6C50.39,365,39.21,337.65,28.46,309l-5.55,9.47Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.58,46.06c8.78,17.86,23.41,33.38,26.34,53.58",
    style: {
      fill: "none",
      stroke: "#231f20",
      strokeMiterlimit: 2.613126039505005,
      strokeWidth: "0.500029981136322px"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M13.32,429.48l7.73,6.3c42,22.41,142.78,20.66,186.91-4.72,13.67-6.2,18.75-17.93,12.75-36.82-9.46-24.27-2.32-19.92-3.5-34.74-.37-4.63-4.84-9.28-5.21-13.92l0-15.06-11.54-20.35L214.37,207.8c6.84-13.62,7-31.24,3-51.35-1.83-9.28-5.07-17.44-6.94-26.35-2.56-12.16-3.13-25.18-7.3-36.63a155,155,0,0,0-25.33-45C133.31,37.11,103.59,66.27,65.52,76.17L28.13,148.39C14,177.44,10.21,201.45,11.23,223.17c1.48,31.56-2.53,63.13-6.07,100.48C3.42,342,1.49,361.35.5,379.78-.66,401.41,2,419.52,13.32,429.48Z",
    style: {
      fill: "none",
      stroke: "#231f20",
      strokeMiterlimit: 2.613126039505005,
      strokeWidth: "0.500029981136322px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.77,503c49.34-2.72,89.36-8.74,97.45-26-.09-15.65-.18-30.23-.26-45.88-47,27-158.43,27.25-194.37,0-.09,15.65-.17,30.23-.26,45.88,8.09,17.3,48.11,23.32,97.44,26Z",
    style: {
      fill: "#404041",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-3)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.52,443l0,8.75C20,457.84,29.36,462.39,41,465.71a199.19,199.19,0,0,0,33.74,6,344.73,344.73,0,0,0,71.74,0,199.47,199.47,0,0,0,34-6c11.68-3.32,21.06-7.87,27.56-13.95l0-8.75-1.42,1.69c-5.89,6.22-15.17,10.85-27.09,14.24a195.76,195.76,0,0,1-33.28,5.89,341.89,341.89,0,0,1-71.3,0A195.37,195.37,0,0,1,42,458.94c-11.92-3.39-21.19-8-27.09-14.24L13.52,443Zm61.24,35.66A194.6,194.6,0,0,1,42,472.83c-11.92-3.39-21.19-8-27.09-14.23l-1.5-1.79,0,8.78c6.51,6.11,15.92,10.68,27.64,14a198.1,198.1,0,0,0,33.64,6,344.76,344.76,0,0,0,72.1,0,198.78,198.78,0,0,0,33.74-6c11.73-3.33,21.14-7.9,27.64-14l-.05-8.78-1.5,1.79c-5.89,6.22-15.17,10.84-27.09,14.23a195.12,195.12,0,0,1-33,5.87,341.33,341.33,0,0,1-71.74,0Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M110.77,503c49.34-2.72,89.36-8.74,97.45-26-.09-15.65-.18-30.23-.26-45.88-47,27-158.43,27.25-194.37,0-.09,15.65-.17,30.23-.26,45.88,8.09,17.3,48.11,23.32,97.44,26Z",
    style: {
      fill: "none",
      stroke: "#231f20",
      strokeMiterlimit: 2.613126039505005,
      strokeWidth: "0.500029981136322px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M72,453c23.49,5.85,41,16.13,53.66,29.92L100,517.23c-22.13-6.67-38.1-16.29-48.62-28.52L72,453Z",
    style: {
      fill: "#404041",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      clipPath: "url(#clip-path-4)"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M112.46,500.54l-4.15,5.55-.49-.63A78.84,78.84,0,0,0,87,488.08a128,128,0,0,0-27.57-11.77l-.75-.19,3.46-6a133.44,133.44,0,0,1,28.25,12.15,85.91,85.91,0,0,1,22.12,18.26Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.82,492l-4.15,5.55-.53-.68a77.74,77.74,0,0,0-21.1-18,127.61,127.61,0,0,0-28.15-12.1l-.78-.14,3.49-6.05a133.31,133.31,0,0,1,28.87,12.53A84.82,84.82,0,0,1,118.82,492Z",
    style: {
      fill: "#fff",
      fillRule: "evenodd"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M72,453c23.49,5.85,41,16.13,53.66,29.92L100,517.23c-22.13-6.67-38.1-16.29-48.62-28.52L72,453Z",
    style: {
      fill: "none",
      stroke: "#231f20",
      strokeMiterlimit: 2.613126039505005,
      strokeWidth: "0.500029981136322px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.62,262.66C94,165,133.38,102.76,153.64,100c37.34-5.09,57.06,40.21,60.48,94.23,4.56,44.22,3,86,.63,124.18-1,15.8-5.67,18-8.77,31.75a266.42,266.42,0,0,1-16.7,50.46c-3.69,8.2-10.25,16.62-14.71,24.16a273.28,273.28,0,0,0-16.31,32.15c-.75,1.81-4.71.53-5.82,2-1.5,2,.5,7.27-1.26,9.12-8.57,9.05-17.76,8.86-25.5,14.78L72,453c4.12-9.84,5.91-23,10.19-32.35,2.65-5.76,8.62-9.36,13-20l1.32-3.24c5.27-12.92,9.26-26.65,14.46-39.78,1.16-2.92,4.71-4.05,6-6.91,1.11-2.47-1.44-6.22-.59-8.89.7-2.21,5.18-2.33,5.94-4.59,1-2.89-4-3.2-3.64-5.07.49-2.6,5.37-2.29,6.26-4.42-.38-1.92-3.56-3.15-3.68-5.11-1.09-17.35-6.31-43.17-6.61-60Z",
    style: {
      fill: "#fff",
      stroke: "#231f20",
      strokeMiterlimit: 2.613126039505005,
      strokeWidth: "0.500029981136322px",
      fillRule: "evenodd"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgViewSide);
export default __webpack_public_path__ + "static/media/view-side.e4d78d1300c66b8865ebd29d1a576885.svg";
export { ForwardRef as ReactComponent };